import React, { Component } from 'react';

class SkinHealthFactor extends Component {
	render() {
		return (
			<section className="assessment  ingredients skin__health">
				<div className="container-fluid">
					<h1 className="assessment__heading">Your Skin health is a factor of?</h1>
					<div className="name__age--badges">
						<span>Skin Type</span>
						<span>Lifestyle</span>
						<span>Environment</span>
						<span>All of the above!</span>
					</div>
				</div>
			</section>
		);
	}
}


export default SkinHealthFactor;